import { encode as base64_encode } from "base-64";
export const generateBase64 = (file, setFile, setError) => {
  const reader = new FileReader();
  reader.readAsBinaryString(file);
  reader.onload = function Success() {
    setFile({
      file,
      base64: base64_encode(reader.result),
      name: file.name,
      type: file.type,
      lastModified: file.lastModified,
      lastModifiedDate: file.lastModifiedDate,
      size: file.size,
      valid: true,
      length: file.size,
    });
    setError("");
  };
  reader.onerror = () => {
    setError("Ocorreu um problema ao subir o arquivo.");
  };
};
